import React from 'react';
import { Link } from 'react-router-dom'
import Practices from '../../api/Practices';

const Sidebar = () => {


    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <div className="col-lg-4 col-md-8 order-lg-1 order-2">
            <div className="wpo-single-sidebar">
                <div className="wpo-service-widget widget">
                    <h2>Practice Areas</h2>
                    <ul>
                        {Practices.map((practice, Pitem) => (
                            <li key={Pitem}><Link onClick={ClickHandler} to={`/practice-single/${practice.slug}`}>{practice.sTitle}</Link></li>
                        ))}
                    </ul>
                </div>
               

                <div className="wpo-contact-widget">
                    <i className="fi flaticon-006-law"></i>
                    <span>Get intouch today</span>
                    <h2>+263 789 099 315</h2>
                    <Link onClick={ClickHandler} to="/contact">Leave us a message</Link>
                </div>
            </div>
        </div>
    )
};
export default Sidebar;

